import { createSlice } from "@reduxjs/toolkit";

// prevent everytime login
const initialState = {
  patientDetailsData: null,
  subjectId: null,
};

const patientDetailsSlice = createSlice({
  name: "patientDetailsReducer",
  initialState,
  reducers: {
    setPatientDetails: (state, action) => {
      state.patientDetailsData = action.payload;
      state.subjectId = action.payload.SubjectId;
    },
  },
});

export const { setPatientDetails } = patientDetailsSlice.actions;
export default patientDetailsSlice.reducer;
